const EducationContentIndicator = ({ content = 'both' }) => {
    return (
        <div className={`education-content-indicator ${content}`}>
            {/* topics-only, tests-only, both */}
        </div >
    )
}

export default EducationContentIndicator